module.exports = __webpack_public_path__ + "img/icon-20.ba074c60.png";